export default __webpack_public_path__ + "static/careers-menu-image-28cefe37e163e1f36733221b9ce39a27.jpg";